<form aria-labelledby="title" [formGroup]="loginForm" (ngSubmit)="onSubmit()">

  @if (isLoginByPhone()) {
    <div class="form-control-group">
      <label class="label" for="input-phone" i18n="@@PhoneNumber">Телефон</label>
      <input
        i18n-placeholder="@@EnterDigitsOnly"
        placeholder="Вводите только цифры"
        phoneMask
        nbInput
        fullWidth
        formControlName="login"
        type="tel"
        maxlength="18"
        name="phone"
        id="input-phone">
    </div>
  } @else {
    <div class="form-control-group">
      <label class="label" for="input-phone" i18n="@@EmailLogin">Email</label>
      <input
        nbInput
        formControlName="login"
        fullWidth
        placeholder="Введите email: пример example@mail.ru"
        autocomplete="off"
        required>
      @if (loginForm.controls.login.errors?.email && loginForm.controls.login.touched) {
        <div class="invalid-feedback">Укажите email</div>
      }
    </div>
  }

  <div class="form-control-group">
    <label class="label" for="input-password" i18n="@@Password">Пароль</label>
    <div class="pass-field">
      <nb-form-field>
        <input nbInput
               minlength="6"
               fullWidth
               formControlName="password"
               [type]="isShowPass ? 'text' : 'password'"
               name="password">
        <button nbSuffix nbButton status="control" type="button" (click)="togglePass()"
                style="background: none; border: none">
          <tui-icon [icon]="isShowPass ? 'eye' : 'eye-closed'"/>
        </button>
      </nb-form-field>
    </div>
  </div>

  <div class="form-control-group form-content__btn">
    <button [disabled]="!loginForm.valid" nbButton
            status="primary"
            size="large"
            i18n="@@SignIn"
            type="submit">
      Войти
    </button>
  </div>
  <div style="text-align: center; margin: 15px 0 0; line-height: 2em">
    <a [routerLink]="[]" (click)="forgot()" i18n="@@ForgotPassword">Забыли пароль?</a>
    <br>
    <a [routerLink]="['/sign-up']" (click)="close()" i18n="@@NotRegisteredYet">Еще не зарегистрированы?</a>
  </div>
</form>
